<template>
  <div class="index index-page">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item,index) in banner" :key="index">
        <div class="carousel-item" :style="{ backgroundImage: 'url(' + item.ImgPath + ')' }"></div>
      </el-carousel-item>
    </el-carousel>

<!--    <div style="margin-top: -600px;"class="video-container">
      <video src="@/assets/first.mp4" autoplay loop muted></video>
      <div class="text-scroll-container">
        <div class="text-scroll-wrapper">
          <span >创新科技<br>&emsp;&emsp;&emsp;共赢未来<br></span>
          <span >科技改变生活<br>&emsp;&emsp;&emsp;&emsp;智能引导未来<br></span>
        </div>
      </div>
      <div class="text-scroll-container-2">
        <div class="text-scroll-wrapper-2">
          <span>☑高效&emsp;&emsp;&emsp;&emsp;&emsp;☑稳定&emsp;&emsp;&emsp;&emsp;&emsp;☑安全<br></span>
          <span>☑移动互联&emsp;&emsp;☑智慧生活&emsp;&emsp;☑人工智能<br></span>
        </div>
      </div>
    </div>-->

    <!-- 新增轮播图 -->
    <div class="custom-carousel-container">
      <swiper ref="customSwiper" :options="customSwiperOption" class="custom-swiper">
        <swiper-slide class="custom-slide">
          <img :src="img_13" alt="轮播图1" class="custom-carousel-image">
        </swiper-slide>
        <swiper-slide class="custom-slide">
          <img :src="img_12" alt="轮播图2" class="custom-carousel-image">
        </swiper-slide>
        <swiper-slide class="custom-slide">
          <img :src="img_14" alt="轮播图3" class="custom-carousel-image">
        </swiper-slide>
        <!-- 分页器 -->
        <div class="swiper-pagination" slot="pagination"></div>
        <!-- 左右箭头 -->
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="con_data_index">
      <div class="meCon">
        <div class="meLeft2">
          <img :src="img_10" alt="" style="width:500px;height:75px">
          <h2>精于品质 · 卓于服务</h2>
          <p>公司基于智慧的理念，建设“砼”世界。采用中华民族的传统印章模式，体现了公司在品质上追求卓著的信念，服务于社会的理想，为“智慧中国”添砖加瓦。</p>
          <a href="/software" class="more">READ MORE</a>
        </div>
        <div class="meRight">
          <div class="d0"><img :src="img_1" alt="" style="width:450px;height:450px"></div>
          <div class="d1"><div class="jumpimg1"><img :src="img_2" alt="" style="width:120px;height:120px"></div></div>
          <div class="d2"><div class="jumpimg2"><img :src="img_3" alt="" style="width:120px;height:120px"></div></div>
          <div class="d3"><div class="jumpimg3"><img :src="img_4" alt="" style="width:120px;height:120px"></div></div>
          <div class="d4"><div class="jumpimg4"><img :src="img_5" alt="" style="width:120px;height:120px"></div></div>
          <div class="d5"><div class="jumpimg5"><img :src="img_6" alt="" style="width:120px;height:120px"></div></div>
          <div class="d6"><div class="jumpimg6"><img :src="img_7" alt="" style="width:120px;height:120px"></div></div>
          <div class="d7"><div class="jumpimg7"><img :src="img_8" alt="" style="width:120px;height:120px"></div></div>
          <div class="d8"><div class="jumpimg8"><img :src="img_9" alt="" style="width:120px;height:120px"></div></div>
        </div>
      </div>

      <div class="store-right">
        <div class="b">成功案例</div>
        <swiper  ref="mySwiper"
                 :options="swiperOption"
                 class="swiper-content swiper-container">
          <swiper-slide class="store-right-item" v-for="(item,index) in win" :key="index">
            <img :src="item.ImgPath" alt="">
          </swiper-slide>
        </swiper>
      </div>

      <div class="meCon">
        <div class="meLeft">
          <h1 class="blue">关于我们</h1>
          <p>北京智砼兴华科技有限公司是一家以物联网、云计算及信息化应用等技术为依托的国家级高新技术企业。公司定位为监测平台开发；监测硬件设备生产、调试、安装、运维；定制AI智能化系统的开发商和服务商，致力于基础设施施工及健康监测行业，并在长沙建立了硬件产品生产基地。
            我们拥有一套成熟的自动化监测体系。即通过安装的传感器及采集模块进行数据自动采集，将采集到的数据可视化报表呈现至系统平台，并进行实时监测数据的在线分析。目前我们平台支持桥梁、基坑、建筑物、边坡、隧道、大坝、路基、气象、尾矿库、特种设备、临时设施（高支模、塔吊等）、铁塔等20余种工况的远距离在线实时监测。</p>
          <a href="/intro" class="more">READ MORE</a>
        </div>
        <div class="meRight">
          <img :src="img_11" alt="" style="width:570px;height:430px">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import baseURL from "../../../vue.config";
require('swiper/dist/css/swiper.css')

export default {
  name: 'c-carousel',
  components:{
    swiper,
    swiperSlide,
  },
  data() {
    return {
      img_0: require('../../assets/24.png'),
      img_1: require('../../assets/1-1.png'),
      img_2: require('../../assets/1-2.png'),
      img_3: require('../../assets/1-3.png'),
      img_4: require('../../assets/1-4.png'),
      img_5: require('../../assets/1-5.png'),
      img_6: require('../../assets/1-6.png'),
      img_7: require('../../assets/1-7.png'),
      img_8: require('../../assets/1-8.png'),
      img_9: require('../../assets/1-9.png'),
      img_10:require('../../assets/log.png'),
      img_11: require('../../assets/01.png'),
      img_12: require('../../assets/index/111.png'),
      img_13: require('../../assets/index/222.png'),
      img_14: require('../../assets/index/333.png'),
      swiperOption: {
        slidesPerView: '4',
        spaceBetween: 0,
        speed: 2000,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay:1500,
          disableOnInteraction: false
        }
      },
      customSwiperOption: {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 1000,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      banner:[],
      win:[], //成功案例

    }
  },
  computed: {
    mySwiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  mounted() {
    this.getImage()
    this.getCarousel()
  },
  methods : {

    //获取轮播
    // getCarousel(){
    //   let data={params:{ImgCate:1}}
    //   this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
    //     res = typeof res.data=='string'? JSON.parse(res.data):res.data;
    //     this.banner = res.data;
    //     console.log(res.data)
    //   })
    // },
    //获取成功案例
    getImage(){
      let data={params:{ImgCate:2}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect',data).then(res=> {
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.win = res.data;
      })
    },

  },


}
</script>

<style >
.carousel-item {
  width: 100%;
  height: 100%;
  background-size: cover;  /* 确保图片覆盖整个容器 */
  background-position: center center;  /* 图片居中 */
  background-repeat: no-repeat;  /* 避免图片重复 */
}
.meCon{
  clear: both;
  margin: 30px 0 50px;
  overflow: hidden;
}
.meLeft{
  float: left;
  width: 520px;
}
.meLeft2{
  float: left;
  width: 520px;
}
.meLeft p{
 line-height: 30px;
}
.meRight{
  float: right;
}

.b{
  width:60px;height: 180px;
  padding: 30px 20px;
  box-sizing: border-box;
  background-color:rgb(0, 106, 184);
  color: #fff;
  font-size: 20px;
  margin: 0 auto;
  line-height: 30px;
  font-weight: bold;
}
.store-right {
  clear: right;
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
  justify-content: left;
}
.swiper-content{
  box-sizing: border-box;
  width: 1090px;
}
.store-right-item {
  margin-top: 5px;
  width: 260px;
  height: 172px;
  background-size: 100% 100%;
}
.el-carousel__container{
  height:450px !important;
  width: 100%;
  overflow: hidden !important;
}
.el-carousel__arrow{
  background-color: rgba(255,255,255,.6)  ;
}
.el-carousel--horizontal{
  overflow: visible !important;
}
.el-carousel__indicators{
  position: absolute;
}

/*首页鼠标互动图片*/
.d0{
  position: relative;
  z-index: 2;
}
.d1{
  position: absolute;
  top:130px;
  left: 860px;
  z-index: 1;
}
.jumpimg1{
   animation: jumpimgHandler1 4s infinite;
 }
.jumpimg1:hover{
  animation: jumpimgHandler1 2s infinite;
}
@keyframes jumpimgHandler1 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d2{
  position: absolute;
  top:185px;
  left: 760px;
  z-index: 3;
}
.jumpimg2{
  animation: jumpimgHandler2 4s ease 2.5s infinite;
}
.jumpimg2:hover{
  animation: jumpimgHandler2 2s infinite;
}
@keyframes jumpimgHandler2 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d3{
  position: absolute;
  top:240px;
  left: 655px;
  z-index: 3;
}
.jumpimg3{
  animation: jumpimgHandler3 4s ease 1s infinite;
}
.jumpimg3:hover{
  animation: jumpimgHandler3 2s infinite;
}
@keyframes jumpimgHandler3 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d4{
  position: absolute;
  top:340px;
  left: 740px;
  z-index: 3;
}
.jumpimg4{
  animation: jumpimgHandler4 4s ease 1.5s infinite;
}
.jumpimg4:hover{
  animation: jumpimgHandler4 2s infinite;
}
@keyframes jumpimgHandler4 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d5{
  position: absolute;
  top:395px;
  left: 860px;
  z-index: 3;
}
.jumpimg5{
  animation: jumpimgHandler5 4s ease 2s infinite;
}
.jumpimg5:hover{
  animation: jumpimgHandler5 2s infinite;
}
@keyframes jumpimgHandler5 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d6{
   position: absolute;
   top:385px;
   left: 980px;
   z-index: 3;
 }
.jumpimg6{
  animation: jumpimgHandler6 4s ease 2.5s infinite;
}
.jumpimg6:hover{
  animation: jumpimgHandler6 2s infinite;
}
@keyframes jumpimgHandler6 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d7{
  position: absolute;
  top:210px;
  left: 1100px;
  z-index: 3;
}
.jumpimg7{
  animation: jumpimgHandler7 4s ease 3s infinite;
}
.jumpimg7:hover{
  animation: jumpimgHandler7 2s infinite;
}
@keyframes jumpimgHandler7 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}

.d8{
  position: absolute;
  top:330px;
  left: 1100px;
  z-index: 3;
}
.jumpimg8{
  animation: jumpimgHandler8 4s ease 3.5s infinite;
}
.jumpimg8:hover{
  animation: jumpimgHandler8 2s infinite;
}
@keyframes jumpimgHandler8 {
  0%{transform: translate(0px,0px);}
  50%{transform: translate(0px,20px);}
  100%{transform: translate(0px,0px);}
}
/*.text-first{
  position: absolute;
  top: 400px;
  left: 150px;
  font-size: 50px;
  font-family: "Microsoft YaHei";
  font-weight: 700;
  color: white;
  line-height: 2.2;
  letter-spacing: 0.5em;
}*/


/*首页视频背景*/
/*.video-container {
  position: relative; !* 相对定位，作为子元素定位基准 *!
  width: 100%; !* 可根据需要添加视频容器的其他样式 *!

}*/
/*首页视频背景上方文字滚动*/
/*.text-scroll-container {
  position: absolute; !* 绝对定位 *!
  top: 57%; !* 垂直居中 *!
  left: 55%; !* 水平居中 *!
  transform: translate(-50%, -50%); !* 精确定位 *!
  width: 100%;
  height: 200px; !* 文字高度 *!
  font-size: 40px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  color: white;
  overflow: hidden;
  background: transparent; !* 透明背景 *!
  z-index: 10; !* 确保在视频上方 *!
  line-height: 2.2;
  letter-spacing: 0.5em;
}

.text-scroll-wrapper {
  position: absolute;
  animation: scroll-up 12s infinite ease-in-out;
}*/

@keyframes scroll-up {
  0% {transform: translateY(0);
    opacity: 0;}
  5% {opacity: 1;
  }
  30% {transform: translateY(0); /* 初始位置停顿 */
    opacity: 1;}
  45% {transform: translateY(-50%); /* 向上滚动 */
  }
  75% {transform: translateY(-50%); /* 顶部位置停顿 */
    opacity: 1;}
  90% {opacity: 0;
  }
  100% {transform: translateY(0); /* 重置位置 */
    opacity: 0;}
}

.text-scroll-container-2 {
  position: absolute; /* 绝对定位 */
  top: 88%; /* 垂直居中 */
  left: 60%; /* 水平居中 */
  transform: translate(-50%, -50%); /* 精确定位 */
  width: 100%;
  height: 80px; /* 文字高度 */
  font-size: 30px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  color: white;
  overflow: hidden;
  background: transparent; /* 透明背景 */
  z-index: 10; /* 确保在视频上方 */
  line-height: 2.2;
  letter-spacing: 0.5em;
}

.text-scroll-wrapper-2 {
  position: absolute;
  animation: scroll-up-2 12s infinite ease-in-out;
}

@keyframes scroll-up-2 {
  0% {transform: translateY(0);
    opacity: 0;}
  5% {opacity: 1;}
  30% {transform: translateY(0); /* 初始位置停顿 */
    opacity: 1;}
  45% {transform: translateY(-50%); /* 向上滚动 */
  }
  75% {transform: translateY(-50%); /* 顶部位置停顿 */
    opacity: 1;}
  90% {opacity: 0;}
  100% {transform: translateY(0); /* 重置位置 */
    opacity: 0;}
}

/* 新增轮播图样式 */
.custom-carousel-container {
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 1200px;
  height: 700px;
  margin: 40px 0;
  position: absolute;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-swiper {
  width: 100%;
  height: 100%;
}

.custom-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  border-radius: 12px;
  overflow: hidden;
}

.custom-carousel-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 12px;
  transition: transform 0.3s ease;
}

.custom-carousel-image:hover {
  transform: scale(1.02);
}

.custom-swiper .swiper-pagination {
  bottom: 20px;
}

.custom-swiper .swiper-pagination-bullet {
  background: #fff;
  opacity: 0.7;
  width: 12px;
  height: 12px;
  margin: 0 6px;
}

.custom-swiper .swiper-pagination-bullet-active {
  background: #006ab8;
  opacity: 1;
}

.custom-swiper .swiper-button-next,
.custom-swiper .swiper-button-prev {
  color: #fff;
  background: rgba(0, 106, 184, 0.8);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  margin-top: -22px;
  transition: all 0.3s ease;
}

.custom-swiper .swiper-button-next:hover,
.custom-swiper .swiper-button-prev:hover {
  background: rgba(0, 106, 184, 1);
  transform: scale(1.1);
}

.custom-swiper .swiper-button-next::after,
.custom-swiper .swiper-button-prev::after {
  font-size: 18px;
  font-weight: bold;
}

/* 调整copyright组件位置，避免与上方组件重叠 - 仅在index页面生效 */
.index.index-page footer.footer {
  margin-top: 150px !important;
  position: relative !important;
  z-index: 1 !important;
}

/* 备用方案 - 使用padding来增加间距 */
.index.index-page .con_data_index {
  padding-bottom: 400px !important;
}
</style>
